export const lightTheme = {
    name: "light",
    background: "#FFF",
    text: "#000",
    lightBackground: "#FFF",
    secondaryBackground: "#d4d4d4",
    secondaryText: "#595959",
};

export const darkTheme = {
    name: "dark",
    background: "#18191A",
    text: "#fff",
    lightBackground: "#2F3136",
    secondaryBackground: "#2F3136",
    secondaryText: "#bfbfbf",
};
